import { defineMessages } from "react-intl";

export const errorMessages = defineMessages({
  externalServiceError: {
    id: "externalServiceError",
    defaultMessage:
      "We're sorry, something went wrong. Please try again in a few hours.",
  },
});
